import { render, staticRenderFns } from "./bannerSet.vue?vue&type=template&id=00aa4ad4&scoped=true&"
import script from "./bannerSet.vue?vue&type=script&lang=js&"
export * from "./bannerSet.vue?vue&type=script&lang=js&"
import style0 from "./bannerSet.vue?vue&type=style&index=0&id=00aa4ad4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa4ad4",
  null
  
)

export default component.exports